import { render, staticRenderFns } from "./AdditionalFieldDropdown.vue?vue&type=template&id=5c3cc9e4"
import script from "./AdditionalFieldDropdown.vue?vue&type=script&lang=js"
export * from "./AdditionalFieldDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports